
  var nh_currency_image = ''; // No image if not set
  var nh_currency_popup_description = '';


//very simple accordion
function toggleAccordion(element) {
        element.parentElement.classList.toggle('active');
}







  function nhCurrencyPopup() {
    console.log('CurrencyPopup');

    // Check if the popup has already been shown
    if (!localStorage.getItem("currencyPopupShown")) {
      // Create the popup
      const popup = document.createElement("div");
      popup.id = "currencyPopup";
      popup.style.position = "fixed";
      popup.style.top = "0";
      popup.style.left = "0";
      popup.style.width = "100%";
      popup.style.height = "100%";
      popup.style.backgroundColor = "rgba(0, 0, 0, 0.9)";
      popup.style.display = "flex";
      popup.style.flexDirection = "column";
      popup.style.justifyContent = "center";
      popup.style.alignItems = "center";
      popup.style.zIndex = "9999";

      // Popup content with heading and two squares
      popup.innerHTML = `
        <div style="text-align: center; margin-bottom: 20px;">
          <h2 style="color: #fff; font-size: 24px;">Choose your Currency</h2>
        </div>
        <div style="display: flex; gap: 20px;">
          <div id="squareEUR">
            <span>€</span>
            <span>EURO</span>
          </div>
          <div id="squareGBP">
            <span>£</span>
            <span>GBP</span>
          </div>
        </div>
        <p style="color: #fff; text-align: center;">${nh_currency_popup_description}</p>
        ${nh_currency_image}
        <button id="closePopup" style="margin-top:20px; padding:10px 20px; border:none; background:#fff; color:#000; cursor:pointer;display:none;">Close</button>
      </div>`;

      document.body.appendChild(popup);

      // Handle square clicks
      document.getElementById("squareEUR").addEventListener("click", function () {
        setCurrency("EUR");
      });

      document.getElementById("squareGBP").addEventListener("click", function () {
        setCurrency("GBP");
      });

      // Close button function
      document.getElementById("closePopup").addEventListener("click", function () {
        popup.remove();
        localStorage.setItem("currencyPopupShown", "true"); // Mark as seen
      });

      // Function to handle currency selection
      function setCurrency(currency) {
        let currentCurrency = new URL(window.location.href).searchParams.get("currency");

        if (currentCurrency !== currency) {
          localStorage.setItem("currencyPopupShown", "true");

          // Redirect to the same page with the new currency parameter
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set("currency", currency);
          window.location.href = currentUrl.toString();
        } else {
          // If same currency is selected, just close the popup
          popup.remove();
          localStorage.setItem("currencyPopupShown", "true");
        }
      }
    }
  } 

  // Run popup when the page is loaded
  document.addEventListener("DOMContentLoaded", function () {
    //nhCurrencyPopup();
  });

  // Add event listeners for currency popup buttons
  document.querySelectorAll('.nhCurrencyPopup').forEach(function (element) {
    element.addEventListener('click', function () {
      localStorage.setItem("currencyPopupShown", "");
      nhCurrencyPopup();
    });




  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.sbEmulute').forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        var parentLi = trigger.closest('li');
        if (parentLi) {
          var button = parentLi.querySelector('button');
          if (button) {
            button.click();
          }
        }
      });
    });
  });

  const backToTop = document.getElementById("backToTop");

  // Show after scrolling 200px
  window.addEventListener("scroll", () => {
    if (window.scrollY > 400) {
      backToTop.classList.add("show");
    } else {
      backToTop.classList.remove("show");
    }
  });

  // Smooth scroll to top
  backToTop.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });



















    
  });
